export default (params) => ({
  trigger: {
    name: 'content_blocks.faq.select_question',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_more',
      params: {
        sub_feature: null,
      },
    },
  },
});
